import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function dispatchClosedStatusClassRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/closed-status-class', component: Index, isProtected: true, permissions: ['closed_status_class_index']},
    {path: '/closed-status-class/create', component: Create, isProtected: true, permissions: ['closed_status_class_create']},
    {path: '/closed-status-class/edit/:id', component: Edit, isProtected: true, permissions: ['closed_status_class_edit']},
  ];

  return routes;
}
